import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

export interface PlaidState {
  plaidData: any;
  error: string | null;
}

const initialState: PlaidState = {
  plaidData: null,
  error: null,
};

const plaidSlice = createSlice({
  name: "plaid",
  initialState,
  reducers: {
    setGlobalPlaidData: (state, action: PayloadAction<any>) => {
      state.plaidData = action.payload;
    },
    setPlaidError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.plaidData = null;
    },
    resetPlaid: (state) => {
      state.plaidData = null;
      state.error = null;
    },
  },
});

export const { setGlobalPlaidData, setPlaidError, resetPlaid } =
  plaidSlice.actions;

export const globalPlaidData = (state: RootState) => state.plaid.plaidData;
export const globalPlaidError = (state: RootState) => state.plaid.error;
export default plaidSlice.reducer;
